
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31.04 20.7"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('style',[_v('.cls-2{fill:#d80027}.cls-3{fill:#0052b4}.cls-4{fill:#f0f0f0}')])]),_c('path',{attrs:{"fill":"#fff","d":"M0 0h31.04v20.69H0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M17.46 0h-3.88v8.41H0v3.88h13.58v8.41h3.88v-8.41h13.58V8.41H17.46V0z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M23.87 13.95l7.17 3.98v-3.98h-7.17zM18.89 13.95l12.15 6.75v-1.91l-8.71-4.84h-3.44zM27.8 20.7l-8.91-4.95v4.95h8.91z"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M18.89 13.95l12.15 6.75v-1.91l-8.71-4.84h-3.44z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M18.89 13.95l12.15 6.75v-1.91l-8.71-4.84h-3.44z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5.48 13.95L0 16.99v-3.04h5.48zM12.15 14.81v5.89H1.55l10.6-5.89z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M8.71 13.95L0 18.79v1.91l12.15-6.75H8.71z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M7.17 6.75L0 2.77v3.98h7.17zM12.15 6.75L0 0v1.91l8.71 4.84h3.44zM3.23 0l8.92 4.95V0H3.23z"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M12.15 6.75L0 0v1.91l8.71 4.84h3.44z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M12.15 6.75L0 0v1.91l8.71 4.84h3.44z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M25.56 6.75l5.48-3.04v3.04h-5.48zM18.89 5.89V0H29.5L18.89 5.89z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M22.33 6.75l8.71-4.84V0L18.89 6.75h3.44z"}})])
          )
        }
      }
    